import { ThemeOptions } from "@mui/material/styles";
import { red } from "@mui/material/colors";

export const AppThemeOptions: ThemeOptions = {
    palette: {
      mode: "light",
      primary: {
        main: "#3f51b5",
      },
      secondary: {
        main: "#f50057",
      },
      error: {
        main: red.A400,
      },
    },
    
  };

